<template>
  <div class="modal modal-full-page fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center modal-full-page__content">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <div class="modal-full-page__text text-left" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        title: '',
        content: ''
      }
    },
    methods: {
      setContent(content) {
        this.content = content
      }
    }
  }
</script>
